export default {
  // 页面标题
  customerCenter: '客商中心',
  rolePermissionManagement: '角色权限管理',

  // 搜索和筛选
  searchPlaceholder: '请输入角色代码、名称或描述',
  statusFilter: '状态筛选',
  statusAll: '全部',
  statusEnabled: '启用',
  statusDisabled: '禁用',
  search: '搜索',
  searchCompleted: '搜索完成',

  // 操作按钮
  addRole: '新增角色',
  editRole: '编辑角色',
  edit: '编辑',
  delete: '删除',
  more: '更多',
  permissionSetting: '权限设置',
  customerConfig: '配置客商',

  // 表格列标题
  roleCode: '角色代码',
  roleName: '角色名称',
  description: '角色描述',
  attribute: '属性',
  status: '状态',
  actions: '操作',

  // 表单字段
  roleCodePlaceholder: '请输入角色代码',
  roleNamePlaceholder: '请输入角色名称',
  attributePlaceholder: '请选择属性',
  descriptionPlaceholder: '请输入角色描述',

  // 属性选项
  attributeCustomer: '客户',
  attributeSupplier: '供应商',

  // 验证消息
  roleCodeRequired: '请输入角色代码',
  roleNameRequired: '请输入角色名称',
  attributeRequired: '请选择属性',

  // 确认对话框
  confirmDelete: '确认删除',
  confirmDeleteContent: '确定要删除角色 "{roleName}" 吗？删除后不可恢复。',

  // 操作结果消息
  addSuccess: '新增成功',
  editSuccess: '编辑成功',
  deleteSuccess: '删除成功',
  statusChangeSuccess: '{roleName} 状态已{status}',

  // 通用
  loading: '加载中...',
  loadDataFailed: '加载数据失败',
  save: '保存',
  cancel: '取消',
  confirm: '确认',

  // 角色客商配置页面
  availableCompanies: '可选公司',
  authorizedCompanies: '已授权公司',
  searchCompanyPlaceholder: '搜索公司名称',
  authorize: '授权',
  unauthorize: '取消授权',
  selectCompaniesToAuthorize: '请先选择要授权的公司',
  selectCompaniesToUnauthorize: '请先选择要取消授权的公司',
  companySaveSuccess: '公司配置保存成功',
  companySaveFailed: '保存失败，请重试',

  // 角色权限配置页面
  availablePermissions: '可选权限',
  authorizedPermissions: '已授权权限',
  searchPermissionPlaceholder: '搜索权限名称',
  selectPermissionsToAuthorize: '请先选择要授权的权限',
  selectPermissionsToUnauthorize: '请先选择要取消授权的权限',
  permissionSaveSuccess: '权限配置保存成功',
  permissionSaveFailed: '保存失败，请重试'
}